<template>
  <div>
    <div v-if="show" class="show-search-bar">
      <div class="show-search-bar-inner">
        <slot name="searchItem"></slot>
        <a class="search-btn" href="javascript:void(0)" @click.prevent="search">
          查詢
        </a>
        <a
          class="close-btn"
          href="javascript:void(0)"
          @click.prevent="searchBarStatus"
        >
          關閉
        </a>
      </div>
    </div>

    <div v-else class="hide-search-bar" @click.prevent="searchBarStatus">
      <span class="search-btn">
        <eva-icon fill="#FFF" name="search-outline"></eva-icon>
      </span>
    </div>
  </div>
</template>

<script>
import moment from "moment";

export default {
  props: ["show"],

  name: "SearchBar",
  data() {
    return {};
  },

  filters: {
    moment: function (date) {
      return moment(date).format("YYYY-MM-DD");
    },
  },

  methods: {
    search() {
      this.$emit("search");
    },

    searchBarStatus() {
      this.$emit("showSearchBar");
    },
  },
};
</script>

<style lang="scss" scoped>
// 顯示狀態
.show-search-bar {
  display: block;
  position: fixed;
  bottom: 50px;
  right: 30px;
  text-align: center;
  z-index: 500;

  @media screen and (max-width: 767px) {
    left: 15px;
    right: 15px;
    bottom: 30px;
  }

  .show-search-bar-inner {
    width: 450px;
    height: 350px;
    overflow-y: auto;
    display: inline-block;
    background-color: #fff;
    box-shadow: 0 2px 5px rgba(0, 0, 0, 0.4);
    padding: 25px 25px 10px 32px;
    border-radius: 30px;
    border: 3px solid #ffc727;

    @media screen and (max-width: 767px) {
      width: 300px;
      right: 0;
      padding: 20px 20px 10px 20px;
    }

    .item-bottom {
      margin-bottom: 10px;
    }

    .search-btn,
    .close-btn {
      display: inline-block;
      border-radius: 25px;
      margin-top: 15px;
      text-decoration: none;
      padding: 0px 10px;
      font-size: 0.8em;
      line-height: 33px;
      cursor: pointer;
      @media screen and (max-width: 767px) {
        margin-top: 10px;
      }
    }

    .search-btn {
      background-color: #5380f7;
      color: #fff;
    }

    .close-btn {
      background-color: #7b7b7b;
      color: #fff;
      margin-left: 15px;
    }
  }
}

// 隱藏狀態
.hide-search-bar {
  cursor: pointer;
  display: block;
  position: fixed;
  bottom: 30px;
  right: 30px;
  padding: 10px 10px;
  border-radius: 25px;
  background: #5380f7;
  z-index: 500;
  @media screen and (max-width: 767px) {
    right: 15px;
  }
}

::-webkit-scrollbar {
  width: 7px;
}

::-webkit-scrollbar-button {
  background: transparent;
  border-radius: 4px;
}

::-webkit-scrollbar-track-piece {
  background: transparent;
}

::-webkit-scrollbar-thumb {
  border-radius: 4px;
  background-color: #aaa;
  border: 1px solid #aaa;
}

::-webkit-scrollbar-track {
  box-shadow: transparent;
}
</style>
